import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { applyMotif, MOTIF_NAMES } from "../lib/motif";
import api from "../lib/api";

const MotifContext = createContext({ motif: "Ivory & Gold", setMotif: () => {} });

export function MotifProvider({ children }) {
  const [motif, setMotifState] = useState("Ivory & Gold");
  const [eventId, setEventId] = useState(null);

  useEffect(() => {
    applyMotif(motif);
  }, [motif]);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/events/current");
        setEventId(data.id);
        if (data.motif && MOTIF_NAMES.includes(data.motif)) setMotifState(data.motif);
      } catch (err) { console.warn("motif: failed to load current event, using default", err); }
    })();
  }, []);

  const setMotif = useCallback(async (name) => {
    setMotifState(name);
    if (eventId) {
      try { await api.put(`/events/${eventId}/motif`, { motif: name }); } catch (err) { console.warn("motif: failed to persist motif change", err); }
    }
  }, [eventId]);

  return (
    <MotifContext.Provider value={{ motif, setMotif, eventId }}>{children}</MotifContext.Provider>
  );
}

export const useMotif = () => useContext(MotifContext);
